import { logStorageQuotaExceeded, logStorageError } from 'src/utils/observability/logs/webview-reload/webviewReloadLogs';

const isQuotaExceededError = (error: unknown): boolean => {
  return error instanceof DOMException && (
    error.name === 'QuotaExceededError' || error.code === 22
  );
};

export const safeSessionStorage: Storage = {
  get length() {
    return sessionStorage.length;
  },
  clear() {
    sessionStorage.clear();
  },
  key(index: number) {
    return sessionStorage.key(index);
  },
  getItem(key: string) {
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key: string, value: string) {
    try {
      sessionStorage.setItem(key, value);
    } catch (error: unknown) {
      const errorMessage = error instanceof Error ? error.message : String(error);
      if (isQuotaExceededError(error)) {
        logStorageQuotaExceeded(errorMessage);
      } else {
        logStorageError(errorMessage);
      }
    }
  },
  removeItem(key: string) {
    try {
      sessionStorage.removeItem(key);
    } catch {
      // silently ignore
    }
  },
};
